import { useRouter } from 'next/router'

// TODO: remove
export const useGetCoursePageUrl = (): string | undefined => {
  const router = useRouter()

  return typeof router.query.coursePath === 'string' ? router.query.coursePath : undefined
}
